'use strict';

const scriptUrl = '//connect.facebook.net/en_US/sdk.js';
const facebook = [
  '$q',
  'jsLoader',
  'auth',
  'config',
  '$window',
  function ($q, jsLoader, auth, config, $window) {
    var loaderPromise;
    var FB;
    var authResponse;

    function getLoaderPromise() {
      if (!loaderPromise) {
        loaderPromise = jsLoader(scriptUrl, 'FB')
          .then(function (fbApi) {
            var deferred = $q.defer();

            FB = fbApi;
            $window.FB.init({
              appId: config.socials.facebook.appId,
              xfbml: false,
              version: 'v15.0'
            });

            $window.FB.getLoginStatus(function(response) {
              if (response.status === 'connected') {
                authResponse = response.authResponse;
              }

              deferred.resolve();
            });

            $window.FB.XFBML.parse();

            return deferred.promise;
          });
      }

      return loaderPromise;
    }

    function loginToFacebook() {
      var deferred = $q.defer();
      if (!authResponse) {
        $window.FB.login(function (response) {
          if (response.status === 'connected') {
            authResponse = response.authResponse;
            deferred.resolve(authResponse);
          } else {
            deferred.reject(response);
          }
        }, { scope: config.socials.facebook.scope });
      } else {
        deferred.resolve(authResponse);
      }

      return deferred.promise;
    }

    function getPhotoUrl(photoId) {
      return 'https://graph.facebook.com/' + photoId + '/picture?access_token=' + authResponse.accessToken;
    }

    function getAlbums() {
      var deferred = $q.defer();

      $window.FB.api('/me/albums?fields=count,name,id', function (response) {
        var albums;

        if (response && !response.error) {
          albums = response.data
            .filter(function (album) {
              return album.count;
            })
            .map(function (album) {
              return {
                id: album.id,
                coverPhoto: 'https://graph.facebook.com/' + album.id + '/picture?access_token=' + authResponse.accessToken,
                name: album.name
              };
            });
          deferred.resolve(albums);
        } else {
          deferred.reject(response);
        }
      });

      return deferred.promise;
    }

    function getPhotosOfYou() {
      var deferred = $q.defer();

      $window.FB.api(`${authResponse.userID}/photos?fields=images`, function (response) {
        if (response && !response.error) {
          var photosOfYou = response.data;
          var photosOfYouAlbum = {};
          if (photosOfYou.length) {
            var photoOfYouCover = photosOfYou[0].images[0].source;
            photosOfYouAlbum = {
              coverPhoto: photoOfYouCover,
              id: -1,
              name: 'Photos of You',
            };
          }
          deferred.resolve(photosOfYouAlbum);
        } else {
          deferred.reject(response);
        }
      });

      return deferred.promise;
    }

    function getPhotos(albumId) {
      var deferred = $q.defer();
      var photos;

      if (albumId === -1) {
        $window.FB.api(`${authResponse.userID}/photos?fields=images`, function (response) {
          if (response && !response.error) {
            var photosOfYou = response.data;
            var photos;
            if (photosOfYou.length) {
              photos = response.data.map(function (photo) {
                var url = photo.images.sort(function(a, b){ return ((a.height + a.width) - (b.height + b.width)); }).pop().source;
                return {
                  id: photo.id,
                  albumId: -1,
                  url: url,
                  src: url
                };
              });
            }
            deferred.resolve(photos);
          } else {
            deferred.reject(response);
          }
        });
      } else {
        $window.FB.api(albumId + '/photos?fields=source,id', function (response) {
          if (response && !response.error) {
            photos = response.data.map(function (photo) {
              return {
                id: photo.id,
                albumId: albumId,
                url: photo.source,
                src: photo.source
              };
            });

            deferred.resolve(photos);
          } else {
            deferred.reject(response);
          }
        });
      }


      return deferred.promise;
    }

    function getPhotoPermissions() {
      var deferred = $q.defer();

      $window.FB.login(function (response) {
        if (response.status === 'connected') {
          authResponse = response.authResponse;
          deferred.resolve(response.authResponse);
        } else {
          deferred.reject(response);
        }
      }, {
        scope: 'user_photos',
        'auth_type': 'rerequest'
      });

      return deferred.promise;
    }

    return {
      login: function () {
        var deferred = $q.defer();

        getLoaderPromise()
          .then(function () {
            return loginToFacebook();
          })
          .then(function (authResponse) {
            return auth.socialLogin('facebook', authResponse.accessToken, authResponse.userID);
          })
          .then(deferred.resolve)
          .catch(deferred.reject);

        return deferred.promise;
      },

      getPhotoPermissions: function () {
        return getPhotoPermissions();
      },

      getAlbums: function () {
        var promise = getLoaderPromise()
          .then(function () {
            return getAlbums();
          });

        return promise;
      },

      getPhotosOfYou: function () {
        var promise = getLoaderPromise()
          .then(function () {
            return getPhotosOfYou();
          });

        return promise;
      },

      getPhotos: function (albumId) {
        var promise = getLoaderPromise()
          .then(function () {
            return getPhotos(albumId);
          });

        return promise;
      },

      sendToMessenger() {
        getLoaderPromise()
        .then(function () {
          $window.FB.XFBML.parse();
        });
      },

      share(url) {
        $window.FB.ui({
          method: 'share',
          display: 'popup',
          href: url,
        }, function() {});
      },

      sendRequest(url) {
        $window.FB.ui({
          method: 'send',
          link: url,
        });
      },

      getPhotoUrl: getPhotoUrl,

      fetchScript: function () {
        return getLoaderPromise();
      }
    };
  }
];

export default facebook;



// WEBPACK FOOTER //
// ./app/src/services/facebook.js